export const ADVANCED_SEARCH_REQUEST = "@@CUSTOMER.ADVANCED_SEARCH.REQUEST";
export const ADVANCED_SEARCH_SUCCESS = "@@CUSTOMER.ADVANCED_SEARCH.SUCCESS";
export const ADVANCED_SEARCH_FAILURE = "@@CUSTOMER.ADVANCED_SEARCH.FAILURE";
